module.exports = __webpack_public_path__ + "static/media/UIUXDesign.ccd5caeb.png";